import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import { StorefrontOutlined } from '@mui/icons-material';
import { useVenueContext } from '../contexts/VenueContext';

export function VenueSwitcherDropdown() {
  const { selectedVenueId, setSelectedVenue, venues, isLoading } = useVenueContext();

  // Hide when only 1 venue (auto-selected)
  if (!isLoading && venues.length <= 1) {
    return null;
  }

  if (isLoading) {
    return (
      <Box sx={{ px: 1.5, py: 0.5 }}>
        <Skeleton variant="rounded" height={40} />
      </Box>
    );
  }

  const handleChange = (event: SelectChangeEvent<string>) => {
    setSelectedVenue(event.target.value as string | 'all');
  };

  return (
    <FormControl fullWidth size="small" sx={{ px: 1.5, py: 0.5 }}>
      <Select
        value={selectedVenueId}
        onChange={handleChange}
        displayEmpty
        sx={{
          fontSize: '0.8125rem',
          fontFamily: '"IBM Plex Sans", sans-serif',
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            py: 0.75,
          },
        }}
        renderValue={(value) => {
          if (value === 'all') {
            return (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <StorefrontOutlined sx={{ fontSize: 18 }} />
                All Venues
              </Box>
            );
          }
          const venue = venues.find((v) => v.id === value);
          return venue?.name || 'Select Venue';
        }}
      >
        <MenuItem value="all">
          <StorefrontOutlined sx={{ fontSize: 18, mr: 1 }} />
          <ListItemText
            primary="All Venues"
            primaryTypographyProps={{ fontSize: '0.8125rem' }}
          />
        </MenuItem>
        {venues.map((venue) => (
          <MenuItem key={venue.id} value={venue.id}>
            <ListItemText
              primary={venue.name}
              primaryTypographyProps={{ fontSize: '0.8125rem' }}
            />
            <Chip
              label={venue.venueType.replace('_', ' ')}
              size="small"
              sx={{
                ml: 1,
                height: 20,
                fontSize: '0.625rem',
                fontWeight: 600,
                textTransform: 'capitalize',
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
